import {
  flushTelemetryEvents,
  recordTelemetryEvent,
} from "$lib/telemetry/telemetry";
import { logger } from "$lib/utils/logger";
import { SOURCE_VERSION } from "virtual:source-version";

// 5-min default (per #299: localizes the 8-10 min fleet collapse, ~20% of the
// key budget); override via VITE_HEARTBEAT_INTERVAL_MS in a test env.
const HEARTBEAT_INTERVAL_MS =
  Number(import.meta.env.VITE_HEARTBEAT_INTERVAL_MS) || 5 * 60 * 1000;

let heartbeatInterval: NodeJS.Timeout | null = null;
let initialHeartbeatTimeout: NodeJS.Timeout | null = null;

function startHeartbeat(): void {
  stopHeartbeatTimers();
  // Jitter the first beat: the fleet reboots together, so beating on mount would
  // stack every screen's key into one minute.
  initialHeartbeatTimeout = setTimeout(() => {
    recordHeartbeat();
    heartbeatInterval = setInterval(recordHeartbeat, HEARTBEAT_INTERVAL_MS);
  }, Math.random() * HEARTBEAT_INTERVAL_MS);
  logger.info("[Heartbeat] recording started.");
}

function cleanupHeartbeat(): void {
  stopHeartbeatTimers();
  logger.info("[Heartbeat] recording stopped.");
}

function stopHeartbeatTimers(): void {
  if (heartbeatInterval) clearInterval(heartbeatInterval);
  heartbeatInterval = null;
  if (initialHeartbeatTimeout) clearTimeout(initialHeartbeatTimeout);
  initialHeartbeatTimeout = null;
}

function recordHeartbeat(): void {
  // Per-screen beat (which screen is dark) plus a displayId-free twin (fleet-clean
  // liveness/version lines).
  recordTelemetryEvent({
    name: "frontend_heartbeat",
    metricType: "counter",
    value: 1,
    tags: { revision: SOURCE_VERSION },
  });
  recordTelemetryEvent({
    name: "frontend_heartbeat",
    metricType: "counter",
    value: 1,
    tags: { revision: SOURCE_VERSION },
    omitDisplayId: true,
  });
  // Flush now: a metric's timestamp is its POST time, so draining on the shared
  // interval would re-align the beat to a fleet-wide tick and undo the jitter.
  flushTelemetryEvents();
}

export { startHeartbeat, cleanupHeartbeat };
